import {Component} from '@angular/core';
/**
 * \@title Configurable checkbox
 */
export class CheckboxConfigurableExample {
  checked = false;
  indeterminate = false;
  align = 'start';
  disabled = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'checkbox-configurable-example',
  templateUrl: 'checkbox-configurable-example.html',
  styleUrls: ['checkbox-configurable-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CheckboxConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
CheckboxConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckboxConfigurableExample.ctorParameters;
/** @type {?} */
CheckboxConfigurableExample.prototype.checked;
/** @type {?} */
CheckboxConfigurableExample.prototype.indeterminate;
/** @type {?} */
CheckboxConfigurableExample.prototype.align;
/** @type {?} */
CheckboxConfigurableExample.prototype.disabled;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
